import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal, { Label } from "../components/Reveal";
import EditorialMarquee from "../components/EditorialMarquee";
import Seo from "../components/Seo";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export default function HowItWorks() {
  const nav = useNavigate();
  const { user } = useAuth();
  const { t } = useLang();
  const steps = [
    { n: "01", t: t("hiw_s1t"), d: t("hiw_s1d") },
    { n: "02", t: t("hiw_s2t"), d: t("hiw_s2d") },
    { n: "03", t: t("hiw_s3t"), d: t("hiw_s3d") },
    { n: "04", t: t("hiw_s4t"), d: t("hiw_s4d") },
    { n: "05", t: t("hiw_s5t"), d: t("hiw_s5d") },
  ];
  return (
    <div>
      <Seo title={t("hiw_label")} description={t("hiw_intro")} path="/comment-ca-marche" />
      <section className="mx-auto max-w-[1400px] px-5 pt-36 pb-16 sm:px-8">
        <Reveal><Label>{t("hiw_label")}</Label></Reveal>
        <Reveal delay={0.05}>
          <h1 className="mt-6 max-w-4xl font-display text-4xl font-900 leading-[0.95] tracking-tighter text-white sm:text-6xl">
            {t("hiw_h1a")}<br /><span className="text-cyan text-glow">{t("hiw_h1b")}</span>
          </h1>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-ink-secondary">
            {t("hiw_intro")}
          </p>
        </Reveal>
      </section>

      <section className="border-y border-white/10 bg-surface">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          {steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div className="group grid items-center gap-6 border-b border-white/10 py-12 last:border-0 md:grid-cols-[auto_1fr] md:gap-16">
                <span className="relative flex items-center leading-none">
                  <span aria-hidden className="absolute -left-3 -top-3 h-16 w-16 rounded-full bg-cyan/15 blur-2xl transition-all duration-300 group-hover:bg-cyan/30" />
                  <span className="relative inline-block bg-gradient-to-br from-cyan via-cyan to-white bg-clip-text font-display text-8xl font-900 text-transparent drop-shadow-[0_0_28px_rgba(0,240,255,0.45)] transition-transform duration-300 group-hover:scale-110 sm:text-9xl">
                    {s.n}
                  </span>
                </span>
                <div>
                  <h3 className="font-display text-2xl font-700 text-white sm:text-3xl">{s.t}</h3>
                  <p className="mt-3 max-w-2xl text-base leading-relaxed text-ink-secondary">{s.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <EditorialMarquee />

      <section className="mx-auto max-w-[1400px] px-5 py-24 text-center sm:px-8">
        <Reveal>
          <p className="mx-auto max-w-3xl font-display text-3xl font-700 leading-snug text-white sm:text-4xl">
            {t("hiw_concl_a")}<br />
            <span className="text-cyan">{t("hiw_concl_b")}</span>
          </p>
          <button
            onClick={() => nav(user ? "/app/deposer" : "/inscription")}
            data-testid="how-cta-deposer"
            className="group mt-10 inline-flex items-center gap-2 bg-cyan px-8 py-4 text-sm font-600 uppercase tracking-wide text-void transition-all hover:-translate-y-0.5 hover:glow-cyan"
          >
            {t("hiw_cta")} <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </button>
        </Reveal>
      </section>
    </div>
  );
}
